import { createSlice } from "@reduxjs/toolkit";
import { deleteDishesAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteDishesSlice = createSlice({
  name: "deleteDishes",
  initialState: data,
  reducers: {
   deleteDishesSlice(state) {
      state.isLoading = true;
    },
   deleteDishesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteDishesSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteDishesSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteDishesHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteDishesAction.deleteDishesSlice());
    const response: any = await deleteDishesAPI(id);
    
    dispatch(deleteDishesAction.deleteDishesSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteDishesAction.deleteDishesSliceFailure(e?.response?.data));
  }
};
export default deleteDishesSlice.reducer;
export const deleteDishesAction = deleteDishesSlice.actions;
